(() => {

  const toggles = document.querySelectorAll('[data-nav-toggle="true"]');
  if (!toggles) return; // ない場合はなにもしない

  toggles.forEach(toggle => {
    toggle.addEventListener('click', event => {
      event.stopPropagation();

      const targetSelector = toggle.getAttribute('data-nav-target');
      if (!targetSelector) return;

      const nav = document.querySelector(targetSelector);
      if (!nav) return;

      const isOpen = nav.getAttribute('aria-disabled') === 'false';
      setNavigationState(nav, !isOpen);

      if (isOpen === 'false') {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }

    });
  });



  // メニュー外クリックで閉じる
  document.addEventListener('click', (event) => {
    const openNavs = Array.from(document.querySelectorAll('nav[aria-disabled="false"][id]'));
    if (openNavs.length === 0) return;

    // トグル類は除外（クリックした瞬間に閉じたりしないように）
    if (event.target.closest('[data-nav-toggle="true"]')) return;

    openNavs.forEach(nav => {
      const content = nav.querySelector('[data-nav-content="true"]');
      if (!content) return; // data-nav-content を付け忘れてたら何もしない

      // content内クリックなら閉じない。content外（オーバーレイ部）なら閉じる
      if (!content.contains(event.target)) {
        setNavigationState(nav, false);
        document.body.style.overflow = 'auto';
      }
    });
  });



  function setNavigationState(nav, open) {
    // 対応する toggle の aria-pressed を同期
    document
      .querySelectorAll(`[data-nav-target="#${nav.id}"]`)
      .forEach(toggle => {
        toggle.setAttribute('aria-pressed', open ? 'true' : 'false');
      });

    nav.setAttribute('aria-disabled', open ? 'false' : 'true');
  }

})();
